import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { FileText } from "lucide-react";

export default function LegalDocViewer({ doc, label, testid }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button type="button" variant="link" data-testid={testid} className="px-0 h-auto text-[#003366]"
        onClick={() => setOpen(true)}>
        {label || `Leggi ${doc.title}`}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid={`${testid}-dialog`} className="max-w-2xl max-h-[85vh] flex flex-col">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 flex-wrap">
              <FileText className="h-5 w-5 text-[#003366]" /> {doc.title}
              <Badge className="bg-amber-100 text-amber-800">Versione {doc.version} — provvisoria</Badge>
            </DialogTitle>
            <DialogDescription>Leggi il documento per intero prima di accettare.</DialogDescription>
          </DialogHeader>
          <div data-testid={`${testid}-content`}
            className="overflow-y-auto whitespace-pre-wrap text-sm text-slate-700 leading-relaxed pr-2">
            {doc.content}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
